$shm_hitalama_map_widget_float_ai_request_html $shm_hitalama_map_widget_float_ai_request_form
	sub /
		<= App_label $mol_labeler
			title \Описание приложения
			content /
			Content <= App $mol_textarea
				value? <=> text?
	next_request_type \html_changes_short
